import { setItem, getItem, setSessionWithNsFun, getSessionWithNsFun, isDef } from '@/utils/index';
import { getOpenid } from '@/api/user';

const setSession = setSessionWithNsFun('carpark');
const getSession = getSessionWithNsFun('carpark');

const state = {
    openid: getSession('openid') || '',
    wxUserInfo: getSession('wxUserInfo') || {},
    projectId: getSession('projectId') || '',
    orderId: getSession('orderId') || '',
    carNumberHistory: getSession('carNumberHistory') || [],
    carNumberDefault: getSession('carNumberDefault') || '',
    setCarDefault: isDef(getSession('setCarDefault')) ? getSession('setCarDefault') : 1,
    couponInfo: getSession('couponInfo') || {}, // 已选择的优惠券
    useCoupon: getSession('useCoupon') || 1 // 是否使用优惠券 1 是 0 否
}

const getters = {
    userCouponGetter: state =>{
        return Number(state.useCoupon)
    }
}

const mutations = {
    SET_OPENID: (state, openid) => {
        state.openid = openid;
        // setItem('openid', openid);
        setSession('openid', openid);
    },
    SET_WXUSERINFO: (state, data={}) => {
        state.wxUserInfo = data;
        setSession('wxUserInfo', data);
    },
    SET_PROJECT_ID: (state, projectId) => {
        state.projectId = projectId;
        setSession('projectId', projectId);
    },
    SET_ORDER_ID: (state, orderId) => {
        state.orderId = orderId;
        setSession('orderId', orderId);
    },
    ADD_CAR_HISTORY: (state, carNumber) => {
        state.carNumberHistory.unshift(carNumber);
        setItem(state.openid + '_carNumberHistory', state.carNumberHistory);
        setSession('carNumberHistory', state.carNumberHistory);

        if(state.setCarDefault == '1') {
            state.carNumberDefault = carNumber;
            setItem(state.openid + '_carNumberDefault', carNumber);
            setSession('carNumberDefault', carNumber);
        }
    },
    SET_CAR_DEFAULT: (state, isDefault) => {
        state.setCarDefault = isDefault;

        setItem(state.openid + '_setCarDefault', isDefault);
        setSession('setCarDefault', isDefault);
    },
    INIT_CAR_STATE: (state) => {
        state.carNumberHistory = Array.from(getItem(state.openid + '_carNumberHistory') || []);
        state.carNumberDefault = getItem(state.openid + '_carNumberDefault') || '';
        state.setCarDefault = isDef(getItem(state.openid + '_setCarDefault')) ? getItem(state.openid + '_setCarDefault') : 1;

        setSession('carNumberHistory', state.carNumberHistory);
        setSession('carNumberDefault', state.carNumberDefault);
        setSession('setCarDefault', state.setCarDefault);
    },

    SET_COUPON_INFO: (state, couponInfo) =>{
        let {   schemeType,
            schemeName,
            couponCode,
            id,
            deductionAmount,
            discountValue,
            effectiveEndDate,
            reliefDuration} = couponInfo
            let obj = {   schemeType,
                schemeName,
                couponCode,
                id,
                deductionAmount,
                discountValue,
                effectiveEndDate,
                reliefDuration}
         if (!couponInfo || couponInfo == {}) {
            state.couponInfo = {}
            setSession('couponInfo', {})
         } else {
            state.couponInfo = obj
            setSession('couponInfo', obj)
         }
        
    },
    SET_USE_COUPON: (state, useCoupon) =>{
        state.useCoupon = useCoupon
        setSession('useCoupon', useCoupon)
    }
}


const actions = {
    addCarHistory({ commit }, carNumber) {
        commit('ADD_CAR_HISTORY', carNumber);
    },
    setCarDefaultVal({ commit }, isDefault) {
        commit('SET_CAR_DEFAULT', isDefault);
    },
    initCarState({ commit }) {
        commit('INIT_CAR_STATE');
    },
    initWxUser({ commit }, code) {
        return new Promise((resolve, reject) => {
            getOpenid(code).then(data => {
                if(data.openid) {
                    // 使用window对象保存，刷新页面会丢失
                    // window.openid = data.openid;
                    commit('SET_OPENID', data.openid)
                    commit('SET_WXUSERINFO', data);
                }

                resolve(data);
            }).catch(err => {
                reject(err);
            })
        })
    }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/carpark.js